import { buildApiUrl } from '../../../shared_app/utils/buildApiUrl';

export const getActivityStream = async (studentId, startDate, endDate) => {
  const response = await fetch(
    buildApiUrl(
      `/api/teachers/students/${studentId}/activity_stream?date=${startDate}&end_date=${endDate}`
    )
  );
  const data = await response.json();
  return data;
};

export const markCardsAsSeen = (studentId, activeStruggleCards, csrfToken) => {
  fetch(buildApiUrl(`/api/teachers/students/${studentId}/mark_seen`), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      session_ids: activeStruggleCards,
      authenticity_token: csrfToken,
    }),
  });
};
